enum PORTAL_ELEMENT_ID {
  MODAL = 'modal-container',
  NAVBAR_DEVICE_GROUP_FILTER = 'device-groups-filter-portal',
  NAVBAR_SHORT_DEVICE_GROUP_FILTER = 'short-menu-device-groups-filter-portal',
  ASIDE = 'aside-container',
}

export {PORTAL_ELEMENT_ID};
